/**
 * Plan-your-wedding template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';
import ThemeTextStackAndCarousel from './lib/partials/ThemeTextStackAndCarousel';
import ThemeBusinessBrowser from './lib/partials/ThemeBusinessBrowser';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Plan-your-wedding';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initThemeTextStackAndCarousel();
	initThemeBusinessBrowser();
}

/**
 * initThemeBusinessBrowser - Initialize the ThemeBusinessBrowser
 * @returns
 */
const initThemeBusinessBrowser = () => {
	Logger.info(`${NAME} > initThemeBusinessBrowser`);

	const dom = document.querySelector(`[data-theme-business-browser]`);
	if (!dom) return;

	const el = new ThemeBusinessBrowser(dom);
	el.init();
}

/**
 * initThemeTextStackAndCarousel - Initialize the theme text stack and carousel
 */
const initThemeTextStackAndCarousel = () => {
	Logger.info(`${NAME} > initThemeTextStackAndCarousel`);

	const themeTextStackAndCarouselDom = document.querySelector('[data-theme-text-stack-and-carousel]');
	if (!themeTextStackAndCarouselDom) return;
	const themeTextStackAndCarousel = new ThemeTextStackAndCarousel(themeTextStackAndCarouselDom);
	themeTextStackAndCarousel.init();
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
